/*eslint-disable no-use-before-define */
import React from 'react';
import AutoSuggestionSelectComponent from '../../../common/auto-suggestion-select/Select';
export const NetworkFilter = ({
  networkProps = networkProps,
  networkChangeHandler: onChange,
}) => {
  return (
    <AutoSuggestionSelectComponent
      options={networkProps.options}
      components={{ IndicatorSeparator: () => null }}
      inputClassName="network-filter height-32 view-member"
      value={networkProps.selectedNetwork}
      onChange={onChange}
      isSearchable={false}
    />
  );
};
